import React, { useState, useEffect, useRef } from "react";
import "../styles/FlipImage.css";
import ContactButton from './ContactButton';
import img1 from '../assets/home-Image/img1.png';
import img2 from '../assets/home-Image/img2.png';
import img3 from '../assets/home-Image/img3.png';
import img4 from '../assets/home-Image/img4.png';
import img5 from '../assets/home-Image/img5.png';
import img6 from '../assets/home-Image/img6.png';
import img7 from '../assets/home-Image/img7.png';
import img8 from '../assets/home-Image/img8.png';
import img9 from '../assets/home-Image/img9.png';


const HeroSection: React.FC = () => {
  const column1Images = [img1, img2, img3, img1, img2, img3];
  const column2Images = [img4, img5, img6, img4, img5, img6];
  const column3Images = [img7, img8, img9, img7, img8, img9];
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  return (
    <div className="bg-cream hero-section-container">
      <div className="hero-section">
        <div className="hero-content">
          <p className="hero-top-text">Revolutionizing Traditional Pipelines</p>
          <h1 className="hero-text-bold">From</h1>
          <h1 className="hero-text-normal">Development to <br />Deployment</h1>
          <div className="cta-new-button-wrapper">
            <ContactButton variant="border">
              Connect with us
            </ContactButton>
          </div>
        </div>

        <div className="hero-card-slide">
        <AutoScrollColumn images={column1Images} direction="down" isMobile={isMobile} />
        <AutoScrollColumn images={column2Images} direction="up" isMobile={isMobile} />
          {!isMobile && <AutoScrollColumn images={column3Images} direction="down" isMobile={isMobile} />}        </div>
      </div>
    </div>
  );
};

const AutoScrollColumn: React.FC<{ images: string[]; direction: 'up' | 'down';  isMobile: boolean;}> = ({ 
  images, 
  direction,
  isMobile
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const scrollPosRef = useRef(0); // ✅ useRef instead of state
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const baseSpeed = 0.5;
    const hoverSpeed = 0.3;
    let animationFrameId: number;

    const scrollImages = () => {
      const container = containerRef.current;
      if (!container) return;

      const currentSpeed = isHovered ? hoverSpeed : baseSpeed;
      const maxScroll = isMobile ? container.scrollWidth / 2 : container.scrollHeight / 2;

      if (direction === 'down') {
        scrollPosRef.current += currentSpeed;
        if (scrollPosRef.current >= maxScroll) scrollPosRef.current = 0;
      } else {
        scrollPosRef.current -= currentSpeed;
        if (scrollPosRef.current <= 0) scrollPosRef.current = maxScroll;
      }

      if (isMobile) {
        container.scrollLeft = scrollPosRef.current;
      } else {
        container.scrollTop = scrollPosRef.current;
      }

      animationFrameId = requestAnimationFrame(scrollImages);
    };

    animationFrameId = requestAnimationFrame(scrollImages);

    return () => cancelAnimationFrame(animationFrameId);
  }, [direction, isHovered, isMobile]); // ✅ Removed scrollPosition from deps

  return (
    <div
      className={`hero-cards-image-container cards-scroll-${direction} ${isMobile ? 'mobile-scroll' : ''}`}
      ref={containerRef}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Render images twice for seamless looping */}
      {[...images, ...images].map((img, index) => (
        <img key={`${index}-${img}`} src={img} alt="" />
      ))}
    </div>
  );
};

export default HeroSection;